import React from 'react';
import { Accordion, AccordionContent, AccordionHeader, Paper, TypographyHeading } from '@honeycomb/ui-core';
import { pushFilterExpanded } from '@honeycomb/tracking';
export function FilterAccordion({ children, heading, id }) {
    const handleChange = (_event, expanded) => {
        pushFilterExpanded(id, expanded);
    };
    return (React.createElement(Paper, { "data-id": "filter_category", "data-key": id },
        React.createElement(Accordion, { id: `filter-accordion-${id}`, defaultExpanded: true, border: "none", onChange: handleChange },
            React.createElement(AccordionHeader, null,
                React.createElement(TypographyHeading, { component: "h5", size: "2xs", color: "text.body" }, heading)),
            React.createElement(AccordionContent, null, children))));
}
